const BACKGROUND_WIDTH = 2108
const BACKGROUND_HEIGHT = 1080

const root = document.documentElement

const adjustBackgroundY = () => {
  const aspect = window.innerWidth / BACKGROUND_WIDTH
  const backgroundScrollHeight = (BACKGROUND_HEIGHT * aspect) - window.innerHeight - 30
  const scrollHeight = root.scrollHeight - window.innerHeight
  const scrollY = root.scrollTop * (backgroundScrollHeight / scrollHeight)

  root.style.setProperty("--background-position", `-${scrollY}px`)
}

// window.addEventListener("scroll", adjustBackgroundY)
// window.addEventListener("resize", adjustBackgroundY)

// adjustBackgroundY()